import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ServiceReportsComponent} from './service-reports/service-reports.component';
import {MaterialModule} from '../material/material.module';
import {UtilitiesModule} from '../utilities/utilities.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ServiceReportService} from './services/service-report.service';
import {InputFieldComponent} from './input-field/input-field.component';
import {FieldSelectorComponent} from './components/field-selector/field-selector.component';
import { ErrorDialogComponent } from './components/error-dialog/error-dialog.component';


@NgModule({
    imports: [
        CommonModule,
        MaterialModule,
        UtilitiesModule,
        FormsModule,
        ReactiveFormsModule,
    ],
    declarations: [
        ServiceReportsComponent,
        InputFieldComponent,
        FieldSelectorComponent,
        ErrorDialogComponent
    ],
    exports: [
        ServiceReportsComponent,
        InputFieldComponent,
        FieldSelectorComponent,
    ],
    providers: [
        ServiceReportService
    ],
    entryComponents: [ErrorDialogComponent]
})
export class ServiceReportModule {
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/servicereport/servicereport.module.ts